module.exports = __webpack_public_path__ + "img/1xiao.05784b25.png";